const ChairishContext = window.chairisher.context;

/**
 * @returns {string} The API key to use with honeybadger js
 */
export function getHoneybadgerJsApiKey() {
    return ChairishContext.HONEYBADGER_JS_API_KEY;
}

/**
 * @returns {boolean} True indicates the honeybadger js feature is enabled; false, if not
 */
export function isHoneybadgerJsEnabled() {
    return !!ChairishContext.IS_HONEYBADGER_JS_ENABLED;
}
